import { useEffect, useState } from "react";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import HomePage from "./pages/HomePage";
import ErrorPage from "./error-page";
import JobsPage from "./pages/JobsPage";
import JobAnalysisPage from "./pages/JobAnalysisPage/JobAnalysisPage";
import "react-toastify/dist/ReactToastify.css";
import { get } from "./services/HttpClient";
import userContext from "./context/userContext";
import jobContext from "./context/jobContext";

export default function App() {
    const routes = [
        {
            path: "/",
            element: <HomePage />,
            errorElement: <ErrorPage />,
        },
        {
            path: "/jobs",
            element: <JobsPage />,
        },
        {
            path: "/job-analysis",
            element: <JobAnalysisPage />,
        },
    ];

    const router = createBrowserRouter(routes, {
        basename: process.env.PUBLIC_URL,
    });

    const [user, setUser] = useState([]);
    const [job, setJob] = useState([]);
    const [greadingScore, setGreadingScore] = useState({});

    return (
        <userContext.Provider value={{ user, setUser  }}>
            <jobContext.Provider value={{ job, setJob,greadingScore,setGreadingScore }}>
                <RouterProvider router={router} />
            </jobContext.Provider>
        </userContext.Provider>
    );
}
